
export default {
    computed: {
        orderStatusList() {
            return [
                { value: 0, label: this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }), color: 'color-primary' },
                { value: 1, label: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }), color: 'color-warning' },
                { value: 2, label: this.$t('fbb.headlogistics.yituihui', { defaultValue: '已退回' }), color: 'color-error' },
                { value: 3, label: this.$t('fbb.headlogistics.daiquerendingcang', { defaultValue: '待确认订舱' }), color: 'color-success' },
                { value: 4, label: this.$t('fbb.headlogistics.baojiayiqueren', { defaultValue: '报价已确认' }), color: 'color-primary' },
                { value: 5, label: this.$t('fbb.headlogistics.yiquxiao', { defaultValue: '已取消' }), color: 'color-error' },
                { value: 6, label: this.$t('fbb.headlogistics.daidingcang', { defaultValue: '待订舱' }), color: 'color-confirm' },
                { value: 7, label: this.$t('fbb.headlogistics.daiqingguan', { defaultValue: '待清关' }), color: 'color-primary' },
                { value: 8, label: this.$t('fbb.headlogistics.daiyuyue', { defaultValue: '待预约' }), color: 'color-success' },
                { value: 10, label: this.$t('fbb.headlogistics.draft_status', { defaultValue: '草稿状态' }), color: 'color-default' },
                { value: 11, label: this.$t('fbb.headlogistics.acceptance_closing', { defaultValue: '验收关闭' }), color: 'color-error' },
                { value: 14, label: this.$t('fbb.headlogistics.daifachuan', { defaultValue: '待发船' }), color: 'color-primary' },
                { value: 15, label: this.$t('fbb.headlogistics.daidaogang', { defaultValue: '待到港' }), color: 'color-primary' },
                { value: 16, label: this.$t('fbb.headlogistics.daituotou', { defaultValue: '待妥投' }), color: 'color-primary' },
                { value: 17, label: this.$t('fbb.headlogistics.yituotou', { defaultValue: '已妥投' }), color: 'color-success' },
                { value: 18, label: this.$t('fbb.headlogistics.zhongzhuandaiyuncang', { defaultValue: '中转待送仓' }), color: 'color-primary' },
                { value: 19, label: this.$t('fbb.headlogistics.daibaoguan', { defaultValue: '待报关' }), color: 'color-primary' },
                { value: 20, label: this.$t('fbb.headlogistics.zhongzhuandaiyuyue', { defaultValue: '中转待预约' }), color: 'color-primary' }
            ]
        },
        queryOrderStatusList() {
            return [
                { index: 0, value: 0, label: this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' }), color: 'color-primary' },
                { index: 1, value: 1, label: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }), color: 'color-warning' },
                { index: 2, value: 2, label: this.$t('fbb.headlogistics.shenhejuhui', { defaultValue: '审核拒回' }), color: 'color-error' },
                { index: 3, value: 3, label: this.$t('fbb.headlogistics.daiquerendingcang', { defaultValue: '待确认订舱' }), color: 'color-success' },
                { index: 4, value: 6, label: this.$t('fbb.headlogistics.daidingcang', { defaultValue: '待订舱' }), color: 'color-confirm' },
                { index: 5, value: 19, label: this.$t('fbb.headlogistics.daibaoguan', { defaultValue: '待报关' }), color: 'color-primary' },
                { index: 6, value: 14, label: this.$t('fbb.headlogistics.daifachuan', { defaultValue: '待发船' }), color: 'color-primary' },
                { index: 7, value: 7, label: this.$t('fbb.headlogistics.daiqingguan', { defaultValue: '待清关' }), color: 'color-primary' },
                { index: 8, value: 15, label: this.$t('fbb.headlogistics.daidaogang', { defaultValue: '待到港' }), color: 'color-primary' },
                { index: 9, value: 18, label: this.$t('fbb.headlogistics.zhongzhuandaiyuncang', { defaultValue: '中转待送仓' }), color: 'color-primary' },
                { index: 10, value: 20, label: this.$t('fbb.headlogistics.zhongzhuandaiyuyue', { defaultValue: '中转待预约' }), color: 'color-primary' },
                { index: 11, value: 8, label: this.$t('fbb.headlogistics.daiyuyue', { defaultValue: '待预约' }), color: 'color-success' },
                { index: 12, value: 16, label: this.$t('fbb.headlogistics.daituotou', { defaultValue: '待妥投' }), color: 'color-primary' },
                { index: 13, value: 17, label: this.$t('fbb.headlogistics.yituotou', { defaultValue: '已妥投' }), color: 'color-success' },
                { index: 14, value: 5, label: this.$t('fbb.headlogistics.yiquxiao', { defaultValue: '已取消' }), color: 'color-error' },
                // { index: 15, value: 4, label: this.$t('fbb.headlogistics.baojiayiqueren', { defaultValue: "保价已确认" }), color: 'color-primary'}
            ]
        },
        logisticsStatusList() {
            return [
                { value: 0, label: this.$t('fbb.headlogistics.chushihua', { defaultValue: '初始化' }), color: 'color-primary' },
                { value: 1, label: this.$t('fbb.headlogistics.daidingcang', { defaultValue: '待订舱' }), color: 'color-warning' },
                { value: 2, label: this.$t('fbb.headlogistics.yidingcang', { defaultValue: '已订舱' }), color: 'color-primary' },
                { value: 3, label: this.$t('fbb.headlogistics.yibaoguan', { defaultValue: '已报关' }), color: 'color-primary' },
                { value: 4, label: this.$t('fbb.headlogistics.yifachuan', { defaultValue: '已发船' }), color: 'color-success' },
                { value: 6, label: this.$t('fbb.headlogistics.yiqingguan', { defaultValue: '已清关' }), color: 'color-primary' },
                { value: 5, label: this.$t('fbb.headlogistics.yidaogang', { defaultValue: '已到港' }), color: 'color-success' },
                { value: 7, label: this.$t('fbb.headlogistics.zhongzhuancangdaoda', { defaultValue: '中转仓到达' }), color: 'color-default' },
                { value: 8, label: this.$t('fbb.headlogistics.yidatuo', { defaultValue: '已打托' }), color: 'color-primary' },
                { value: 9, label: this.$t('fbb.headlogistics.yiyuyue', { defaultValue: '已预约' }), color: 'color-primary' },
                { value: 10, label: this.$t('fbb.headlogistics.yituotou', { defaultValue: '已妥投' }), color: 'color-primary' },
                { value: 11, label: this.$t('fbb.headlogistics.chayanzhong', { defaultValue: '查验中' }), color: 'color-default' },
            ]
        },
        transportList() {
            return [{
                label: this.$t('fbb.headlogistics.fcl_by_sea', { defaultValue: '海运整柜' }),
                value: 0,
            }, {
                label: this.$t('fbb.headlogistics.air_transport', { defaultValue: '空运' }),
                value: 1
            }, {
                label: this.$t('fbb.headlogistics.ltl_by_sea', { defaultValue: '海运拼箱' }),
                value: 6
            }, {
                label: this.$t('fbb.headlogistics.express', { defaultValue: '快递' }),
                value: 8
            }]
        },
        gettransportType() {
            return [
                { value: 0, label: this.$t('fbb.headlogistics.fcl_by_sea', { defaultValue: '海运整柜' }) },
                { value: 1, label: this.$t('fbb.headlogistics.air_transport', { defaultValue: '空运' }) },
                { value: 6, label: this.$t('fbb.headlogistics.ltl_by_sea', { defaultValue: '海运拼箱' }) },
                { value: 7, label: this.$t('fbb.headlogistics.lcl_by_sea', { defaultValue: '自拼箱' }) },
                { value: 8, label: this.$t('fbb.headlogistics.express', { defaultValue: '快递' }) },
                { value: 9, label: this.$t('fbb.headlogistics.sea_transport', { defaultValue: '海运' }) },
                { value: 99, label: '--' },
            ]
        },
        ticketStatus() {
            return [
                { value: 10, label: this.$t('fbb.headlogistics.unupload', { defaultValue: '未上传' }), color: 'color-default' },
                { value: 20, label: this.$t('fbb.headlogistics.uploaded', { defaultValue: '已上传' }), color: 'color-primary' },
                { value: 30, label: this.$t('fbb.headlogistics.confirmmed', { defaultValue: '已确认' }), color: 'color-success' }
            ]
        },
        exceptionStatus() {
            return [
                { value: 0, label: this.$t('fbb.headlogistics.no_exceptioin', { defaultValue: '无异常' }), color: 'color-default' },
                // { value: 1, label: '修改异常', color: 'color-error' },
                // { value: 2, label: '物流延迟异常', color: 'color-error' },
                // { value: 3, label: '物流预约时间异常', color: 'color-error' },
                { value: 4, label: this.$t('fbb.headlogistics.exception_ship', { defaultValue: '发船延迟' }), color: 'color-error' },
                { value: 5, label: this.$t('fbb.headlogistics.exception_port', { defaultValue: '到港延迟' }), color: 'color-error' },
                { value: 6, label: this.$t('fbb.headlogistics.exception_warehouse', { defaultValue: '中转仓到达延迟' }), color: 'color-error' },
                { value: 7, label: this.$t('fbb.headlogistics.exception_appointment', { defaultValue: '预约延迟' }), color: 'color-error' },
                { value: 8, label: this.$t('fbb.headlogistics.exception.delivered', { defaultValue: '妥投延迟' }), color: 'color-error' }
            ]
        },
        logisticsTypeList() {
            return [{
                value: 'through',
                label: this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直达' })
            }, {
                value: 'transfer',
                label: this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' })
            }]
        }

    },
    methods: {
        // 最新预计到仓时间展示逻辑
        getShowNewStatus (status) {
            let statusItem = this.queryOrderStatusList.filter(item => {
                return status === item.value
            })[0];
            if (statusItem.index >= 7) {
                return true;
            }
            else {
                return false;
            }
        },
        /**
         * 获取两个数组的交集
         * @param {array} containerArr 
         * @param {array} selectArr 
         * @returns {array} 两个数组的交集
         */
        handleSearch(containerArr, selectArr) {
            let result = []
            if (!selectArr) {
                result = containerArr
            }
            else {
                result = containerArr.filter(item => selectArr.includes(item))
            }
            return result
        },
        /**
         * 验证集装箱号
         * @param {array} data {id: '', data: {extra_cabinet_20GP_qty: 0}}
         * @returns {boolean} 是否通过验证 
         */
        validInbounds(originData) {
            let keyArr = [{
                key: 'extra_cabinet_20GP_qty',
                keyName: this.$t('fbb.headlogistics.20gp_number', { defaultValue: '20GP数量' }),
                valid: 'extra_cabinet_20GP_no',
                validName: this.$t('fbb.headlogistics.20gp_container_number', { defaultValue: '20GP集装箱号' })
            }, {
                key: 'extra_cabinet_40GP_qty',
                keyName: this.$t('fbb.headlogistics.40gp_number', { defaultValue: '40GP数量' }),
                valid: 'extra_cabinet_40GP_no',
                validName: this.$t('fbb.headlogistics.40gp_container_number', { defaultValue: '40GP集装箱号' })
            }, {
                key: 'extra_cabinet_40HQ_qty',
                keyName: this.$t('fbb.headlogistics.40hq_number', { defaultValue: '40HQ数量' }),
                valid: 'extra_cabinet_40HQ_no',
                validName: this.$t('fbb.headlogistics.40hq_container_number', { defaultValue: '40HQ集装箱号' })
            }, {
                key: 'extra_cabinet_45HQ_qty',
                keyName: this.$t('fbb.headlogistics.45hq_number', { defaultValue: '45HQ数量' }),
                valid: 'extra_cabinet_45HQ_no',
                validName: this.$t('fbb.headlogistics.45hq_container_number', { defaultValue: '45HQ集装箱号' })
            }]
            let access = true
            originData.map(item => {
                let hasDataCount = 0
                keyArr.map(sItem => {
                    let num = item.data[sItem.key]
                    if (num) {
                        hasDataCount++
                        if (!item.data[sItem.valid]) {
                            // this.$VMessage.error(`入库单${item.id}的${sItem.validName}未填写`)
                            this.$VMessage.error(this.$t('fbb.headlogistics.inbound_error_1', { '0': item.id, '1': sItem.validName, defaultValue: `入库单${item.id}的${sItem.validName}未填写` }))
                            access = false
                        }
                        else {
                            let data = item.data[sItem.valid].split(',')
                            if (data.length !== num) {
                                // this.$VMessage.error(`入库单${item.id}的${sItem.validName}与填写的数量不符`)
                                this.$VMessage.error(this.$t('fbb.headlogistics.inbound_error_2', { '0': item.id, '1': sItem.validName, defaultValue: `入库单${item.id}的${sItem.validName}与填写的数量不符` }))
                                return access = false
                            }
                            data.map((tItem, index) => {
                                if (!/^[A-Z]{4}\d{7}$/.test(tItem)) {
                                    // this.$VMessage.error(`入库单${item.id}的${sItem.validName}中的第${index + 1}个填写不正确,如需分隔请使用英文逗号`)
                                    this.$VMessage.error(this.$t('fbb.headlogistics.inbound_error_3', { '0': item.id, '1': sItem.validName, '2': index + 1, defaultValue: `入库单${item.id}的${sItem.validName}中的第${index + 1}个填写不正确,如需分隔请使用英文逗号` }))
                                    return access = false
                                }
                            })
                        }
                    }
                })
                if (hasDataCount === 0) {
                    access = false
                    // this.$VMessage.error(`入库单${item.id}至少要填写一组集装箱数据`)
                    this.$VMessage.error(this.$t('fbb.headlogistics.inbound_error_4', { '0': item.id, defaultValue: `入库单${item.id}至少要填写一组集装箱数据` }))
                }
            })
            return access
        },
        /**
         * 获取按钮列表
         * @param {number} carrierType 贷代类型 0 标准 1 其他
         * @param {string} logisticsType 发运类型 transfer 中转 through 直达
         * @param {number} orderStatus 单据状态
         * @param {boolean} isNormal 是否正常（判断是否需要展示恢复正常按钮）
         * @param {number} invoiceStatus 发票状态 10 未上传 20 已上传 30 已确认
         * @param {boolean} getAll 是否返回全部按钮
         * @param {number} podStatus POD状态 20 已上传
         * @returns {Array}
         */
        buttonList(carrierType, logisticsType, orderStatus, isNormal, invoiceStatus, getAll, podStatus) {
            let btnArr = [
                // {
                //     tag: 0,
                //     text: '提交',
                //     theme: 'primary',
                //     type: 2
                // }, 
                {
                    // 创建 用于操作历史
                    text: this.$t('global.common.create', { defaultValue: '创建' }),
                    type: 1,
                    hide: true
                },
                {
                    // 提交 用于操作历史
                    text: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                    type: 2,
                    hide: true
                },
                {
                    tag: 1,
                    text: this.$t('fbb.headlogistics.examine', { defaultValue: '审核' }),
                    theme: 'warning',
                    component: 'comExam',
                    hide: !this.handleAuth('fbb.logisticsHead.check'),
                    type: 3
                }, {
                    tag: 18,
                    text: this.$t('fbb.headlogistics.examine', { defaultValue: '审核' }),
                    theme: 'warning',
                    component: 'comExamOther',
                    hide: !this.handleAuth('fbb.logisticsHead.check'),
                    width: 800,
                    type: 3
                }, {
                    tag: 2,
                    text: this.$t('fbb.headlogistics.querendingcang', { defaultValue: '确认订舱' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.check'),
                    data: {
                        componentName: 'comBookingSpace',
                        type: 'confirmBookingSpace'
                    },
                    type: 7
                }, {
                    tag: 3,
                    text: this.$t('fbb.headlogistics.dingcang', { defaultValue: '订舱' }),
                    theme: 'primary',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        componentName: 'comBookingSpace',
                        type: 'hasConfirmBookingSpace'
                    },
                    type: 9
                }, {
                    tag: 4,
                    text: this.$t('fbb.headlogistics.baoguan', { defaultValue: '报关' }),
                    theme: 'primary',
                    width: 800,
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        componentName: 'comDeclare'
                    },
                    type: 10
                }, {
                    tag: 5,
                    text: this.$t('fbb.headlogistics.fachuan', { defaultValue: '发船' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        componentName: 'comBookingSpace',
                        type: 'shipping'
                    },
                    type: 11
                }, {
                    tag: 6,
                    text: this.$t('fbb.headlogistics.qingguan', { defaultValue: '清关' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        type: 'clearCustoms'
                    },
                    type: 13
                }, {
                    tag: 7,
                    text: this.$t('fbb.headlogistics.daogang', { defaultValue: '到港' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        type: 'reachPort'
                    },
                    type: 12
                }, {
                    tag: 8,
                    text: this.$t('fbb.headlogistics.shangchuanfapiao', { defaultValue: '上传发票' }),
                    theme: 'info',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update') || podStatus !== 20,
                    data: {
                        type: 'uploadBill'
                    },
                    type: 19
                }, {
                    tag: 9,
                    text: this.$t('fbb.headlogistics.querenfapiao', { defaultValue: '确认发票' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.check'),
                    data: {
                        type: 'confirmBill'
                    },
                    type: 20
                }, {
                    tag: 16,
                    text: this.$t('fbb.headlogistics.zhongzhuanyuyue', { defaultValue: '中转预约' }),
                    theme: 'primary',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        type: 'transitAppointment'
                    },
                    type: 21
                }, {
                    tag: 17,
                    text: this.$t('fbb.headlogistics.zhongzhuancangdaoda', { defaultValue: '中转仓到达' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: !this.handleAuth('fbb.logisticsHead.update'),
                    data: {
                        type: 'transitArrive'
                    },
                    type: 15
                }, 
                {
                    tag: 10,
                    text: '预约',
                    // theme: 'primary',
                    // component: 'compModal',
                    // hide: !this.handleAuth('fbb.logisticsHead.update'),
                    hide: true,
                    // data: {
                    //     type: 'appointment'
                    // },
                    type: 17
                }, 
                {
                    tag: 11,
                    text: '妥投',
                    // theme: 'success',
                    // component: 'compModal',
                    // hide: !this.handleAuth('fbb.logisticsHead.update'),
                    hide: true,
                    // data: {
                    //     type: 'delivered'
                    // },
                    type: 18
                }, 
                {
                    tag: 19,
                    text: this.$t('fbb.headlogistics.yunfeiluru', { defaultValue: '运费录入' }),
                    theme: 'success',
                    component: 'compModal',
                    data: {
                        type: 'freight'
                    },
                    type: 34
                }, 
                {
                    tag: 12,
                    text: this.$t('fbb.headlogistics.huifuzhengchang', { defaultValue: '恢复正常' }),
                    theme: 'success',
                    component: 'compModal',
                    hide: isNormal || !this.handleAuth('fbb.logisticsHead.recovery'),
                    data: {
                        type: 'backToNormal'
                    },
                    type: 33
                }, 
                {
                    tag: 20,
                    text: this.$t('fbb.headlogistics.fachuanchongtui', { defaultValue: '发船重推' }),
                    theme: 'warning',
                    data: {
                        type: 'pushAgain'
                    },
                    type: 51
                }, {
                    tag: 13,
                    text: this.$t('fbb.headlogistics.tianjiabeizhu', { defaultValue: '添加备注' }),
                    theme: 'info',
                    component: 'compModal',
                    data: {
                        type: 'remark'
                    },
                    type: 40
                }, {
                    tag: 14,
                    text: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    theme: 'error',
                    hide: !this.handleAuth('fbb.logisticsHead.cancel'),
                    component: 'compModal',
                    data: {
                        type: 'cancel'
                    },
                    type: 32
                }, {
                    tag: 22,
                    text: this.$t('fbb.headlogistics.upload_pod', { defaultValue: '上传POD' }),
                    theme: 'warning',
                    // 已妥投
                    // hide: orderStatus !== 17,
                    component: 'compModal',
                    data: {
                        type: 'uploadPOD'
                    },
                    type: 22
                    
                }, {
                    // tag: 15,
                    // text: '返回'
                }, {
                    // 审核拒回的type为50
                    // tag: 21,
                    text: this.$t('fbb.headlogistics.shenhejuhui', { defaultValue: '审核拒回' }),
                    hide: true,
                    type: 50
                }, {
                    // 其他货代审核
                    text: this.$t('fbb.headlogistics.examine', { defaultValue: '审核' }),
                    hide: true,
                    type: 43
                }, {
                    // 异常操作提醒
                    text: this.$t('fbb.headlogistics.yichangtixing', { defaultValue: '异常提醒' }),
                    hide: true,
                    type: 52
                }, {
                    text: this.$t('fbb.headlogistics.chuangjianzhongzhuanjihua', { defaultValue: '创建中转计划' }),
                    hide: true,
                    type: 53
                }, {
                    // 历史数据需要加
                    text: this.$t('fbb.headlogistics.datuo', { defaultValue: '打托' }),
                    hide: true,
                    type: 14
                }, {
                    text: this.$t('fbb.headlogistics.yichangtixing', { defaultValue: '异常提醒' }),
                    hide: true,
                    type: 60
                }, {
                    tag: 23,
                    text: '最新预计到仓时间',
                    theme: 'primary',
                    component: 'compChangeDate',
                    // hide: !this.getShowNewStatus(orderStatus),
                    type: 62
                }, {
                    tag: 24,
                    text: '更新预计到仓时间',
                    theme: 'info',
                    component: 'compModal',
                    data: {
                        componentName: 'compExpectWarehouseDate',
                        type: 'updateArriveDate'
                    },
                    type: 63
                } ,{
                    // 创建 用于操作历史
                    text: '更新入库计划单号',
                    type: 64,
                    hide: true
                }, {
                    // 更新预估费用
                    tag: 25,
                    text: "更新预估费用",
                    theme: "primary",
                    component: "compCost",
                    type: 65
                }]
                //tag 25  type 65

            if (getAll) {
                return btnArr
            }

            let result = []
            // 需要去掉的按钮的tag
            let deleteTagArr = []
            // 需要保留的按钮的tag
            let hasTagArr = [1, 2, 3, 4]
            // 标准-直达
            if (carrierType === 0 && (logisticsType === 'through' || !logisticsType)) {
                deleteTagArr = [18, 16, 17, 19]
                switch (orderStatus) {
                    //草稿
                    case 0:
                        hasTagArr = [13, 14, 15]
                        break
                    // 待审核
                    case 1:
                        hasTagArr = [1, 12, 13, 14, 15]
                        break
                    // 已退回/审核拒回
                    case 2:
                        hasTagArr = [0, 12, 13, 14, 15]
                        break
                    // 待确认订舱
                    case 3:
                        hasTagArr = [2, 12, 13, 14, 15]
                        break
                    // 待订舱
                    case 6:
                        hasTagArr = [3, 12, 13, 14, 15, 24, 25]
                        break
                    // 待报关
                    case 19:
                        hasTagArr = [4, 12, 13, 14, 15, 24, 25]
                        break
                    // 待发船
                    case 14:
                        hasTagArr = [5, 12, 13, 14, 15, 23, 25]
                        break
                    // 待清关
                    case 7:
                        hasTagArr = [6, 12, 13, 20, 15, 23, 25]
                        break
                    // 待到港
                    case 15:
                        hasTagArr = [7, 12, 13, 20, 15, 23, 25]
                        break
                    // 待预约
                    case 8:
                        hasTagArr = [10, 11, 12, 13, 20, 15, 23, 25]
                        break
                    // 待妥投
                    case 16:
                        hasTagArr = [11, 12, 13, 20, 15, 23, 25]
                        break
                    // 已妥投
                    case 17:
                        // 发票未上传
                        if (invoiceStatus === 10) {
                            hasTagArr = [8, 12, 13, 20, 22, 15, 23, 25]
                        }
                        // 发票已上传
                        else if (invoiceStatus === 20) {
                            hasTagArr = [8, 9, 12, 13, 20, 22, 15, 23, 25]
                        }
                        // 发票已确认
                        else {
                            hasTagArr = [12, 13, 20, 22, 15, 23, 25]
                        }
                        break
                    default:
                        hasTagArr = [12, 13, 15]
                        break
                }
            }
            // 标准-转运
            else if (carrierType === 0 && logisticsType === 'transfer') {
                deleteTagArr = [10, 11, 19]
                switch (orderStatus) {
                    // // 草稿
                    // case 10:
                    //     hasTagArr = [0, 13, 14, 15]
                    //     break
                    // 待审核
                    case 1:
                        hasTagArr = [1, 12, 13, 14, 15]
                        break
                    // 审核拒回/已退回
                    case 2:
                        hasTagArr = [0, 12, 13, 14, 15]
                        break
                    // 待确认订舱
                    case 3:
                        hasTagArr = [2, 12, 13, 14, 15]
                        break
                    // 待订舱
                    case 6:
                        hasTagArr = [3, 12, 13, 14, 15, 24, 25]
                        break
                    // 待预约
                    case 8:
                        hasTagArr = [12, 13, 20, 15, 25]
                        break
                    // 待报关
                    case 19:
                        hasTagArr = [4, 12, 13, 14, 15, 24, 25]
                        break
                    // 待发船
                    case 14:
                        hasTagArr = [5, 12, 13, 14, 15, 23, 25]
                        break
                    // 待清关
                    case 7:
                        hasTagArr = [6, 12, 13, 20, 15, 23, 25]
                        break
                    // 待到港
                    case 15:
                        hasTagArr = [7, 12, 13, 20, 15, 23, 25]
                        break
                    // 中转待预约
                    case 20:
                        hasTagArr = [16, 17, 12, 13, 20, 15, 23, 25]
                        break
                    // 中转待送仓
                    case 18:
                        hasTagArr = [17, 12, 13, 20, 15, 23, 25]
                        break
                    // 待妥投
                    case 16:
                        hasTagArr = [12, 13, 20, 15, 23, 25]
                        break
                    // 已妥投
                    case 17:
                        // 发票未上传
                        if (invoiceStatus === 10) {
                            hasTagArr = [8, 12, 13, 20, 22, 15, 23, 25]
                        }
                        // 发票已上传
                        else if (invoiceStatus === 20) {
                            hasTagArr = [8, 9, 12, 13, 20, 22, 15, 23, 25]
                        }
                        // 发票已确认
                        else {
                            hasTagArr = [12, 13, 20, 22, 15, 23, 25]
                        }
                        break
                    default: {
                        hasTagArr = [12, 13, 15]
                        break
                    }
                }
            }
            // 其他
            else if (carrierType === 1) {
                deleteTagArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 16, 17, 10]
                switch (orderStatus) {
                    // 草稿
                    case 0:
                        // hasTagArr = [0, 13, 14, 15]
                        hasTagArr = [12, 13, 14, 15]
                        break
                    // 待审核
                    case 1:
                        hasTagArr = [18, 12, 13, 14, 15]
                        break
                    // 审核拒回
                    case 2:
                        // hasTagArr = [0, 13, 14, 15]
                        hasTagArr = [12, 13, 14, 15]
                        break
                    // 待妥投
                    case 16:
                        hasTagArr = [11, 12, 13, 20, 15, 23, 25]
                        break
                    // 已妥投
                    case 17:
                        hasTagArr = [19, 12, 13, 20, 22, 15, 23, 25]
                        break
                    default: {
                        hasTagArr = [12, 13, 15]
                        break
                    }
                }
            }

            result = btnArr.filter(item => {
                let flag = true
                let needflag = false
                for (let i = 0; i < deleteTagArr.length; i++) {
                    if (item.tag === deleteTagArr[i]) {
                        flag = false
                        break
                    }
                }
                if (flag) {
                    for (let i = 0; i < hasTagArr.length; i++) {
                        if (item.tag === hasTagArr[i]) {
                            needflag = true
                            break
                        }
                    }
                }
                if (needflag) {
                    return item
                }
            })
            // console.log(result)
            return result
            // return btnArr
        },
    }
}